import TruckerListMobile from './TruckerListMobile';

export default TruckerListMobile;
